/* eslint-disable @typescript-eslint/no-explicit-any */
import axios from 'axios';
import EnvService from '@/services/environment/EnvService';
import IVideoServiceRaw from '@/services/videos/IVideoServiceRaw';
import PlayerMapper from '@/data/mappers/PlayerMapper';
import Player from '@/data/Player';
import PlayoutService from '@/services/videos/PlayoutService';
import ContextInfo from '@/data/settings/ContextInfo';

export default class VideoServiceRawMgnl implements IVideoServiceRaw {

  private player: Player = new Player('0', 'none', false);
  private baseUrl: string;

  public constructor(contextInfo: ContextInfo) {
    let contextPath = contextInfo.contextPath;
    if(!contextPath) contextPath = '';
    if(contextPath?.startsWith('/')) {
      contextPath = contextPath.slice(1, contextPath.length);
    }
    if(contextPath?.endsWith('/')) {
      contextPath = contextPath.slice(0, contextPath.length - 1);
    }

    this.baseUrl = contextPath
      ? ('/' + contextPath + '/' + EnvService.getEnvVar('VUE_APP_MGNL_MOVINGIMAGE_REST_URI')).replace('//', '/')
      : EnvService.getEnvVar('VUE_APP_MGNL_MOVINGIMAGE_REST_URI');

    if(!this.baseUrl.endsWith('/')) {
      this.baseUrl += '/';
    }
  }

  /* eslint-disable-next-line  @typescript-eslint/no-empty-function */
  public async init() {
    this.player = await this.getPlayer();
  }

  public async getPlayer(): Promise<Player> {

    if(this.player.id != '0') {
      return this.player;
    }

    const url = `${this.baseUrl}players`;

    const res = await axios({
      method: 'get',
      url
    });

    if(res.data.length === undefined) {
      this.throwUnexpectedDataError(url, res.data);
    }
    this.player = PlayerMapper.mapFromObject(res.data);
    return this.player;
  }

  public async getChannels(): Promise<any> {
    
    const url = `${this.baseUrl}channels`;
  
    const res = await axios({
      method: 'get',
      url
    });

    if(!res.data.id) {
      this.throwUnexpectedDataError(url, res.data);
    }
    return res.data;
  }

  /* eslint-disable-next-line  @typescript-eslint/no-unused-vars */
  public async getChannelMetaData(channelId: number) {
    return undefined;
  }

  public async getChannelsInfoDefinition(workspace: string, absJcrPropertyPath: string): Promise<string> {

    const url = `${this.baseUrl}channels-info`;
    const queryParams = new URLSearchParams();
    queryParams.set('workspace', workspace);
    queryParams.set('absJcrPropPath', absJcrPropertyPath);

    const res = await axios.get(url, {
      params: queryParams,
      headers: {
        'Content-Type': 'plain/text'
      }
    });

    return res.data;
  }

  public async getVideos(queryParams: URLSearchParams) {
    return await this._getVideos(queryParams, 'videos');
  }

  public async getRelatedVideos(queryParams: URLSearchParams) {
    return await this._getVideos(queryParams, 'relatedvideos');
  }

  /* eslint-disable-next-line  @typescript-eslint/no-unused-vars */
  public async getThumbnails(videoId: string) {
    return undefined;
  }

  public async getVideoData(videoId: string) {
    return new PlayoutService().getVideoData(videoId, this.player.id);
  }

  public hasRemoteSort(): boolean {
    return true;
  }

  public getStoredPlayer(): Player {
    return this.player;
  }

  private async _getVideos(queryParams: URLSearchParams, pathFragment: string) {
    const url = `${this.baseUrl}${pathFragment}`;

    const res = await axios.get(url, {
      params: queryParams,
    });

    if(!res.data.videos || res.data.videos.length === undefined || res.data.total === undefined) {
      this.throwUnexpectedDataError(url, res.data);
    };
    return res.data;
  }

  /* eslint-disable-next-line  @typescript-eslint/no-explicit-any */
  private throwUnexpectedDataError(url: string, data: any) {
    throw new Error(`Received unexpected data from request to ${url}: ${data}`);
  }
}